/**
 * Per-field help text for Workforce / Daemon hire form. Single source of
 * truth — both the inline <HelpIcon> and the right-sidebar Field Help drawer
 * on /workforce/new read from this map (entity-management guidelines §4).
 */
export const DAEMON_FIELD_HELP: Record<string, string> = {
  name: 'Human-readable identifier, shown on the Workforce list and in findings/audit trails. Pick something descriptive like "SecurityGuardian" or "ResearchOperative" — you will see this name a lot.',

  department:
    'Functional grouping (research / security / quality / testing / docs / performance / infrastructure / custom). Used for filtering and to route findings to the right reviewers.',

  type: 'Guardian enforces rules (blocks bad commits, rejects risky trades). Sentinel watches patterns and raises alerts without taking action. Operative builds and automates — the most permissive class. Pick the one that matches the primary behavior.',

  mandate:
    "The employee's mission statement — 1–3 sentences. Injected into the agent's system prompt. Specific mandates produce consistent outputs; vague mandates produce meandering ones.",

  templateId:
    'Numeric ID of the agent template this employee uses. The template supplies the system prompt, tool list, and task profile. Leave empty for a raw employee with no template inheritance (advanced).',

  permissionTier:
    'Observer produces findings/docs/alerts only. Contributor adds the ability to submit PRs and code changes. Operator adds external-API calls and system actions — the most dangerous tier. Raise the tier only when the role needs it.',

  requiresApproval:
    "When on, every action the employee takes waits for a human reviewer before applying. Use this for contributor/operator tiers until you trust the employee's output. Can be turned off later in the employee's config.",

  workflowDefinitionId:
    "Optional. The primary workflow this employee runs on each trigger. Leave empty if you will wire workflows later from the employee's detail page.",

  triggers:
    'What starts a run: cron schedule, an event pattern (e.g. "strategy:signal"), a chained-from-another-employee trigger, or manual only. You can add multiple triggers; each one independently kicks off the employee.',

  supervisorDaemonId:
    "Optional. Another employee that reviews this one's findings before they surface to humans. Useful for newly-hired employees on probation — set this to a trusted senior employee.",

  probationDays:
    'Optional. During probation, every output is double-checked by the supervisor. After the probation window ends, outputs surface directly (subject to requiresApproval + permission tier). Leave empty for no probation.',
};
